import { BackToTopButton } from "components/ui/buttons";
import ImportLeadBasicInformationTable from "./ImportLeadBasicInformationTable";
import ImportLeadOtherInformationTable from "./ImportLeadOtherInformationTable";

function ImportLeadOverview() {
    // Statisches Lead
    const importLeadDetailsInfo = {
        leadId: "lead5",
        firstName: "Peter",
        lastName: "Schneider",
        productName: "Stationäre Pflege", // Product.PropertiesRetirement
        email: "peter.schneider@example.com", // Beispielwert
        age: 68, // Beispielwert
        careLevel: "Pflegestufe II", // Beispielwert
        source: "Importiert", // Beispielwert
        clientTitle: "Herr", // Beispielwert
        requestRegion: "Stuttgart",
        requestZipCode: "70173",
        phoneNumber: "+49 711 1234567", // Beispielwert
        comments: "Keine weiteren Anmerkungen",
        otherInformations: [
            { name: "Lead-Nummer", value: "ANF-005" },
            { name: "Erstellt am (UTC)", value: "06.05.2025" },
            { name: "Phase", value: "In Bearbeitung" },
            { name: "Priorität", value: "Hoch" },

        ]
    };

    return (
        <div className="lead-container">
            <BackToTopButton />

            <h1 className="text-blue">
                Anfrage: {importLeadDetailsInfo.otherInformations.find(o => o.name === "Lead-Nummer")?.value}
            </h1>

            <div className="flex-nowrap align-center">
                <h3 className="highlight-green">
                    <span className="icons icons-icon-import overview-icon"></span>{" "}
                    <span className="import-message">
                        Sie haben eine neue Anfrage importiert.
                    </span>
                </h3>
            </div>

            {/* Basis-Informationen */}
            <ImportLeadBasicInformationTable
                firstName={importLeadDetailsInfo.firstName}
                lastName={importLeadDetailsInfo.lastName}
                productName={importLeadDetailsInfo.productName}
                email={importLeadDetailsInfo.email}
                age={importLeadDetailsInfo.age.toString()}
                careLevel={importLeadDetailsInfo.careLevel}
                source={importLeadDetailsInfo.source}
                clientTitle={importLeadDetailsInfo.clientTitle}
                requestRegion={importLeadDetailsInfo.requestRegion}
                requestZipCode={importLeadDetailsInfo.requestZipCode}
                phoneNumber={importLeadDetailsInfo.phoneNumber}
                comments={importLeadDetailsInfo.comments}
            />

            {/* Sonstige Informationen */}
            <ImportLeadOtherInformationTable
                otherInformationList={importLeadDetailsInfo.otherInformations}
            />
        </div>
    );
}

export default ImportLeadOverview;
